import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/QuantityToggle/sgds-quantity-toggle";
import { register } from "../../utils/ce-registry";

register("sgds-quantity-toggle", Component);

export default createComponent({
  react: React,
  tagName: "sgds-quantity-toggle",
  elementClass: Component,
  events: {
    onSgdsChange: "sgds-change",
    onSgdsInput: "sgds-input"
  }
});
